import AbstractApi from './Abstract';
import {
  AuthApi,
  CartApi,
  CatalogApi,
  ContentApi,
  NewCatalogApi,
  OrderApi,
  UserApi,
  LoyaltyApi,
} from './Domains';

const MAIN_URL = process.env.REACT_APP_API_URL;
const PICS_URL = '';  // 'http://127.0.0.1:8000';

class Api extends AbstractApi {
  constructor(MAIN_URL) {
    super(MAIN_URL);

    this.auth = new AuthApi(this);
    this.user = new UserApi(this);
    this.order = new OrderApi(this);
    this.newCatalog = new NewCatalogApi(this);
    this.content = new ContentApi(this);
    this.cart = new CartApi(this);
    this.catalog = new CatalogApi(this);
    this.loyalty = new LoyaltyApi(this);
  }
}

export { Api, MAIN_URL, PICS_URL };
